'use strict';

import React, { Component, PropTypes } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { get } from 'lodash';

@connect(store => {
  return {
    labels: get(store, 'labels.DeterminationOfStatus', {})
  };
})
export default class DeterminationOfStatus extends Component {
  
  static propTypes = {
    labels: PropTypes.object
  }

  state = {
    openAccordion: null
  }

  toggleExpanded(newVal) {
    this.setState({
      openAccordion: newVal
    });
  }

  render() {
    const startDate = new Date(this.props.profile.availabilityDate);
    const now = (new Date());
    const diff = Math.round((startDate - now)/(1000*60*60*24));
    const tooSoon = diff > 45 && diff < 120;
    const {
      openAccordion
    } = this.state;

    this.state.openAccordion = this.props.labels.subAccordionData[0].header;

    return (
      <ul className='expanded-accordion-content sub-accordion'>
        {
          this.props.labels.subAccordionData.map((datum, i) =>
            <li key={i} className={cx('callout', {'sub-accordion-item': datum.content.length > 0}, {expanded: openAccordion === datum.header})}>
                <div data-id={datum.header}
                     className='sub-accordion-header noTextSelect'
                     onClick={this.toggleExpanded.bind(this, openAccordion === datum.header ? null : datum.header)}
                     dangerouslySetInnerHTML={{__html: datum.header}}>

                </div>
                <ul className={cx('text-list', {bullet: datum.content.length > 1})}>
                  {
                    datum.content.map((textRow, j) => {
                      if (j !== datum.content.length - 1 || !datum.tooSoonItem || tooSoon) {
                        return  (
                          <li data-id={`Instructions List Item ${j}`}
                              key={j} className='accordion-text'>
                            {textRow}
                          </li>
                        );
                      }
                      })
                  }
                </ul>
            </li>
          )
        }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/Steps/Interview/f_DeterminationOfStatus/index.js